// extracted by mini-css-extract-plugin
export default {"form-check":"CheckBox_form-check__AxR2n","formCheckCustom":"CheckBox_formCheckCustom__GOayd"};